<script setup>
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 10,
  },
});

const emit = defineEmits(['update:modelValue']);

const canDecrease = computed(() => props.modelValue > props.min);
const canIncrease = computed(() => props.modelValue < props.max);

function decrease() {
  if (canDecrease.value) {
    emit('update:modelValue', props.modelValue - 1);
  }
}

function increase() {
  if (canIncrease.value) {
    emit('update:modelValue', props.modelValue + 1);
  }
}
</script>

<template>
  <div class="flex items-center justify-start w-[180px] rounded-full gap-4">
    <button
      type="button"
      class="w-[32px] h-[32px] rounded-full bg-black text-white flex items-center justify-center disabled:opacity-20 cursor-pointer"
      :disabled="!canDecrease"
      aria-label="Decrease"
      @click="decrease"
    >
      <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2L2 2" stroke="white" stroke-width="3" stroke-linecap="square" />
      </svg>
    </button>
    <span
      class="text-lg rounded-full bg-white text-primary-dark w-[52px] h-[52px] shrink-0 text-center leading-[52px] font-bold"
      >{{ modelValue }}</span
    >
    <button
      type="button"
      class="w-[32px] h-[32px] rounded-full bg-black text-white flex items-center justify-center disabled:opacity-20 cursor-pointer"
      :disabled="!canIncrease"
      aria-label="Increase"
      @click="increase"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00195 2L9.00195 16M16.4414 9L1.5625 9"
          stroke="white"
          stroke-width="3"
          stroke-linecap="square"
        />
      </svg>
    </button>
  </div>
</template>
